import { Grid } from '@mui/material';
import Container from '@mui/material/Container';
import LinearProgress from '@mui/material/LinearProgress';
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import EduAccountGuard from 'src/components/guards/EduAccountGuard';
import MainLayout from 'src/layouts/main';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));
const DataSets = lazy(() => import('src/pages/DataSets'));
const HomePage = lazy(() => import('src/pages/HomePage'));
const Support = lazy(() => import('src/pages/Support'));
const Users = lazy(() => import('src/pages/Users'));
const UserDetail = lazy(() => import('src/pages/UserDetail'));
const LogHistory = lazy(() => import('src/pages/LogHistory'));
const PendingApproval = lazy(() => import('src/pages/PendingApproval'));
const RejectedApproval = lazy(() => import('src/pages/RejectedApproval'));
const NewWorldReading = lazy(() => import('src/pages/NewWorldReading'));
const NewWorldReadingLanding = lazy(() => import('src/pages/NewWorldReadingLanding'));
const Profile = lazy(() => import('src/pages/Profile'));
const Api = lazy(() => import('src/pages/Api'));
const Gates = lazy(() => import('src/pages/Gates'));
const MathMatrixOverview = lazy(() => import('src/math-matrix/MathMatrixOverview'));
const MathMatrixDashboard = lazy(() => import('src/math-matrix/MathMatrixDashboard'));

// ----------------------------------------------------------------------

const fallbackLoader = (
  <Container maxWidth="lg">
    <Grid spacing={2} mt={13} p={10}>
      <LinearProgress />
    </Grid>
  </Container>
);

export const mainRoutes = [
  {
    element: (
      <MainLayout>
        <Suspense fallback={fallbackLoader}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      { path: '404', element: <Page404 /> },
      { path: 'home', element: <HomePage /> },
      { path: 'mathMatrix/overview', element: <MathMatrixOverview /> },
      { path: 'mathMatrix/dashboard', element: <MathMatrixDashboard /> },
      {
        path: 'dataLagoon',
        element: (
          <EduAccountGuard>
            <Gates />
          </EduAccountGuard>
        ),
      },
      { path: 'support', element: <Support /> },
      { path: 'contact-us', element: <Support /> },
      { path: 'about-us', element: <Support /> },
      {
        path: 'datasets',
        element: (
          <EduAccountGuard>
            {' '}
            <DataSets />{' '}
          </EduAccountGuard>
        ),
      },
      { path: 'users', element: <Users /> },
      { path: 'users/:id', element: <UserDetail /> },
      { path: 'loghistory', element: <LogHistory /> },
      { path: 'profile', element: <Profile /> },
      { path: 'newWorldsReading', element: <NewWorldReadingLanding /> },
      { path: 'nwrDashboard', element: <NewWorldReading /> },
      { path: 'api', element: <Api /> },
      { path: 'pending-approval', element: <PendingApproval /> },
      { path: 'rejected-approval', element: <RejectedApproval /> },
    ],
  },
];
